// Get jQuery from global scope
const $ = window.jQuery;

// Search and category filters.
$(".category-filter-dropdown").on("change", function () {
  $("#filter-blog").submit();
});

// Sync search input with hidden field and trigger form submission
jQuery("#search-blog").on("keyup search", function () {
  jQuery("#search-blog-hidden").val(jQuery(this).val());
  jQuery("#filter-blog").submit();
});

$("#filter-blog").submit(function () {
  var filter = $("#filter-blog");
  $.ajax({
    url: filter.attr("action"),
    data: filter.serialize(),
    type: filter.attr("method"),
    success: function (data) {
      $("#response-blog").html(data);
    },
  });
  var blog_search_value = $("#search-blog").val().toLowerCase();
  $("#response-blog .post").filter(function () {
    $("#response-blog .post").toggle(
      $("#response-blog .post")
        .find("h3")
        .text()
        .toLowerCase()
        .indexOf(blog_search_value) > -1,
    );
  });
  return false;
});

// Blog Load More functionality
const loadMoreBlogBtn = document.getElementById("load-more-blog");
const showLessBlogBtn = document.getElementById("show-less-blog");

if (loadMoreBlogBtn) {
  loadMoreBlogBtn.addEventListener("click", function (e) {
    e.preventDefault();

    const button = this;
    const currentPage = parseInt(button.getAttribute("data-page"));
    const maxPages = parseInt(button.getAttribute("data-max-pages"));
    const nextPage = currentPage + 1;

    // Show loading state
    button.textContent = "Loading...";
    button.disabled = true;

    const formData = new FormData();
    formData.append("action", "load_more_blog");
    formData.append("page", nextPage);
    formData.append("nonce", ajax_variable.blog_nonce);

    fetch(ajax_variable.ajax_url, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          const container = document.getElementById("response-blog");
          container.insertAdjacentHTML("beforeend", data.html);

          button.setAttribute("data-page", nextPage);

          // Use setProperty with "important" so these toggles win over the
          // button mixin's `display: inline-flex !important`.
          if (nextPage >= maxPages) {
            // No more pages — hide Show More, show Show Less
            button.style.setProperty("display", "none", "important");
            if (showLessBlogBtn) {
              showLessBlogBtn.style.setProperty("display", "inline-flex", "important");
            }
          } else {
            // More pages remain — keep Show More visible, also show Show Less
            button.textContent = "Show More";
            button.disabled = false;
            if (showLessBlogBtn) {
              showLessBlogBtn.style.setProperty("display", "inline-flex", "important");
            }
          }
        } else {
          button.textContent = "Show More";
          button.disabled = false;
        }
      })
      .catch(() => {
        button.textContent = "Show More";
        button.disabled = false;
      });
  });
}

if (showLessBlogBtn) {
  showLessBlogBtn.addEventListener("click", function (e) {
    e.preventDefault();

    const container = document.getElementById("response-blog");
    const allPosts = container.querySelectorAll(".blog-related-block__post");

    // Remove all posts after the initial 8
    allPosts.forEach((post, index) => {
      if (index >= 8) {
        post.remove();
      }
    });

    // Reset Show More button
    if (loadMoreBlogBtn) {
      loadMoreBlogBtn.setAttribute("data-page", "1");
      loadMoreBlogBtn.style.setProperty("display", "inline-flex", "important");
      loadMoreBlogBtn.textContent = "Show More";
      loadMoreBlogBtn.disabled = false;
    }

    // Hide Show Less button
    showLessBlogBtn.style.setProperty("display", "none", "important");

    // Scroll back to the post container
    container.scrollIntoView({ behavior: "smooth", block: "start" });
  });
}

var post_page = 1;
$(document).on(
  "click",
  ".post-listing-with-pagination .category-drodown-item .btn-category",
  function () {
    const selectedText = $(this).text();
    const selectedDataValue = $(this).data("value");
    $(".post-listing-with-pagination .category-dropdown").text(selectedText);
    $(".post-listing-with-pagination .category-dropdown").data(
      "value",
      selectedDataValue,
    );
    $(".post-listing-with-pagination .category-drodown-item").slideUp();
    $(this).parents("ul").find(".btn-category").removeClass("active");
    $(this).addClass("active");
    var selectedCategory = $(this).data("value");
    var searchQuery = $(
      ".post-listing-with-pagination .post-search-input",
    ).val();
    updatePaginationControls(post_page);
    post_filter(post_page, selectedCategory, searchQuery);
  },
);

$(".post-listing-with-pagination .post-search-input").on("keyup", function () {
  var searchQuery = $(this).val();
  var selectedCategory = $(
    ".post-listing-with-pagination .btn-category.active",
  ).data("value");
  post_filter(post_page, selectedCategory, searchQuery);
});

$(document).on(
  "click",
  ".post-listing-wrapper .pagination .dots, .post-listing-wrapper .pagination .icon-btn",
  function (e) {
    e.preventDefault();

    var newPage = $(this).data("page");

    var selectedCategory = $(
      ".post-listing-with-pagination .btn-category.active",
    ).data("value");
    var searchQuery = $(
      ".post-listing-with-pagination .post-search-input",
    ).val();
    // Update active state for dots
    $(".post-listing-wrapper .pagination .dots").removeClass("active");
    $(
      '.post-listing-wrapper .pagination .dots[data-page="' + newPage + '"]',
    ).addClass("active");
    post_page = newPage;
    updatePaginationControls(post_page);
    $("html, body").animate(
      {
        scrollTop: $(".post-listing-wrapper").offset().top,
      },
      "slow",
    );
    // Fetch new posts
    post_filter(post_page, selectedCategory, searchQuery);
  },
);

function post_filter(post_page, selectedCategory, searchQuery) {
  jQuery.ajax({
    type: "post",
    url: ajax_variable.ajax_url,
    data: {
      action: "action__post_filters",
      nonce: ajax_variable.post_filter_nonce,
      page: post_page,
      category: selectedCategory,
      search: searchQuery,
    },
    dataType: "JSON",
    cache: false,
    success: function (res) {
      if (res.response == "success") {
        $("#post-listing").html(res.message);
        $(".post-listing-wrapper .pagination-wrapper").html(res.pagination);
        updatePaginationControls(post_page);
      } else {
        $("#post-listing").html(
          '<div style="text-align: center;width: 100%;">No posts found.</div>',
        );
        $(".post-listing-wrapper .pagination-wrapper").empty();
      }
    },
  });
}
function updatePaginationControls(post_page) {
  var total = $(".post-listing-wrapper .pagination").data("max");
  if (post_page == 1) {
    $(".post-listing-wrapper .prev-page")
      .addClass("disabled")
      .css({ "pointer-events": "none", opacity: "0.2" });
  } else {
    $(".post-listing-wrapper .prev-page")
      .removeClass("disabled")
      .css({ "pointer-events": "auto", opacity: "1" });
  }
  if (post_page == total) {
    $(".post-listing-wrapper .next-page")
      .addClass("disabled")
      .css({ "pointer-events": "none", opacity: "0.2" });
  } else {
    $(".post-listing-wrapper .next-page")
      .removeClass("disabled")
      .css({ "pointer-events": "auto", opacity: "1" });
  }
}
